module.exports = __webpack_public_path__ + "img/cambiar_fechas_icon.png";